export const INITIAL_STATE_FOR_CREATE_PROJECT = {
	projectName: '',
	projectType: {},
	projectOwner: {},
	projectStartDate: '',
	projectEndDate: '',
	brand: {},
	buyer1stMeetingDate: '',
	buyerSignOffDate: '',
	season: '',
	styleCategoryDetails: '',
	fabricDetails: '',
	note: ''
};

export const PROJECT_TYPES = [
	{ value: 'Pick and choose (P&C)', id: 'PICK_AND_CHOOSE' },
	{ value: 'Create and collaborate (C&C)', id: 'CREATE_AND_COLLABORATE' },
	{ value: 'Buyer techpack development', id: 'BUYER_DEVELOPMENT' },
	{ value: 'Buyer visit in UK', id: 'BUYER_VISIT_IN_UK' },
	{ value: 'Buyer visit in SP', id: 'BUYER_VISIT_IN_SP' },
	{ value: 'Buyer visit in BD', id: 'BUYER_VISIT_IN_BD' },
	{ value: 'New collection program', id: 'NEW_COLLECTION_PROGRAM' },
	{ value: 'Fabric or swatch program', id: 'FABRIC_OR_SWATCH_PROGRAM' },
	{ value: 'Graphics program', id: 'GRAPHICS_PROGRAM' },
	{ value: 'Wash program', id: 'WASH_PROGRAM' },
	{ value: 'Onboarding new customer', id: 'ONBOARDING_NEW_CUSTOMER' },
	{ value: 'Onboarding new department', id: 'ONBOARDING_NEW_DEPARTMENT' },
	{ value: 'Opening new core program', id: 'OPENING_NEW_CORE_PROGRAM' },
	{ value: 'Buyer Sign Off', id: 'BUYER_SIGN_OFF' },
	{ value: "New collection (visit to brand's office)", id: 'NEW_COLLECTION_VISIT_TO_BRAND_OFFICE' },
	{ value: 'General', id: 'GENERAL' }
];

export const PROJECT_STATUS = [
	{ value: 'Not started', id: 'PENDING', name: 'Not Started', constant: 'PENDING' },
	{ value: 'Running', id: 'RUNNING', name: 'Running', constant: 'RUNNING' },
	{ value: 'Completed', id: 'COMPLETED', name: 'Completed', constant: 'COMPLETED' }
];

// Status tag definitions
export const STATUS_TAGS = [
	{ id: 1, name: 'In Progress', color: 'blue' },
	{ id: 2, name: 'Pending', color: 'yellow' },
	{ id: 3, name: 'Not Started', color: 'gray' },
	{ id: 4, name: 'Completed', color: 'green' }
];

// Priority tag definitions
export const PRIORITY_TAGS = [
	{ id: 1, name: 'High', color: 'red', constant: 'HIGH', value: 'High', className: 'red-3' },
	{ id: 2, name: 'Medium', color: 'orange', constant: 'MEDIUM', value: 'Medium', className: 'orange-3' },
	{ id: 3, name: 'Low', color: 'green', constant: 'LOW', value: 'Low', className: 'gray-2' }
];

export const PROJECT_DETAILS_TABLE_COLUMNS = [
	{ id: 'TASK', name: 'Task', key: 'taskName' },
	{ id: 'COMMENTS', name: 'Comments', key: 'comments' },
	{ id: 'OWNER', name: 'Owner', key: 'owner' },
	{ id: 'START_DATE', name: 'Start Date', key: 'startDate', icon: '/icons/info.svg" ' },
	{ id: 'DUE_DATE', name: 'Due Date', key: 'dueDate', icon: '/icons/info.svg" ' },
	{ id: 'STATUS', name: 'Status', key: 'status', icon: '/icons/info.svg" ' },
	{ id: 'PRIORITY', name: 'Priority', key: 'priority' },
	{ id: 'REMARKS', name: 'Remarks', key: 'remarks' }
];

export const TASK_COLUMNS = {
	TASK: 'TASK',
	COMMENTS: 'COMMENTS',
	OWNER: 'OWNER',
	STATUS: 'STATUS',
	DUE_DATE: 'DUE_DATE',
	PRIORITY: 'PRIORITY',
	START_DATE: 'START_DATE',
	REMARKS: 'REMARKS'
};

export const COLOR_CODE_LIST = [
	'#1D4ED8', // Darker blue
	'#CC2121', // Dark red
	'#B7950B', // Dark yellow
	'#FC9403', // Dark blue
	'#7D3C98', // Dark purple
	'#03FC6B', // Dark green
	'#A04000', // Dark brown
	'#FFFF00', // Dark orange
	'#008080' // Dark violet
];

export const INITIAL_TASK_STATE = {
	name: '',
	taskStatusTagRequest: null,
	taskPriorityTagRequest: null,
	taskStatusTagResponse: null,
	taskPriorityTagResponse: null,
	ownerResponse: [],
	dueDate: '',
	startDate: '',
	remarks: '',
	taskGroupId: null,
	isNewTaskRow: false
};

export const TASK_SECTION_TABS = [
	{
		name: 'Table',
		id: 'TABLE_VIEW'
	},
	{
		name: 'Kanban',
		id: 'KANBAN_VIEW'
	},
	{
		name: 'Files',
		id: 'FILES_VIEW'
	}
];

export const MIX_PANEL_EVENTS = {
	PROJECT_LIST_ON_CLICK: 'PROJECT_LIST_ON_CLICK',
	PROJECT_DETAILS_VIEW: 'PROJECT_DETAILS_VIEW',
	PROJECT_ON_DRAG: 'PROJECT_ON_DRAG', //
	PROJECT_TASK_LIST_VIEW_CHANGE: 'PROJECT_TASK_LIST_VIEW_CHANGE',
	PROJECT_TASK_ON_DRAG: 'PROJECT_TASK_ON_DRAG',
	// PROJECT_TASK_EDIT: 'PROJECT_TASK_EDIT',
	PROJECT_TASK_COMMENT_PANEL_ON_CLICK: 'PROJECT_TASK_COMMENT_PANEL_ON_CLICK',
	PROJECT_TASK_LIST_FILTER: 'PROJECT_TASK_LIST_FILTER',
	PROJECT_TASK_COLUMN_VISIBILITY_ON_CHANGE: 'PROJECT_TASK_COLUMN_VISIBILITY_ON_CHANGE',
	PROJECT_ADD_LINK: 'PROJECT_ADD_LINK',
	ENTITY_LINK_ON_CLICK: 'ENTITY_LINK_ON_CLICK'
};

export const TAG_COLORS_LIST = [
	'#00C334',
	'#FCB400',
	'#F22B2B',
	'#C7CED4',
	'#3B82F6',
	'#FF08C2',
	'#06A09B',
	'#CE623E',
	'#21242B'
];

export const PROJECT_TAB_VIEW_TYPES = {
	KANBAN: 'KANBAN',
	CALENDAR: 'CALENDAR',
	LIST: 'LIST',
	CARD: 'CARD'
};

export const PROJECT_TABLE_STATUS = {
	PENDING: 'gray-2',
	RUNNING: 'yellow-3',
	COMPLETED: 'green-3',
	NOT_STARTED: 'gray-2'
};

export const PROJECT_TABLE_PRIORITY = {
	HIGH: 'red-3',
	MEDIUM: 'yellow-1',
	LOW: 'gray-1'
};

export const SORTING_COLUMNS = {
	BUYER_FIRST_SELECTION_DATE: 'BUYER_FIRST_SELECTION_DATE',
	BRAND: 'BRAND',
	PROJECT_TYPE: 'PROJECT_TYPE',
	PROJECT_NAME: 'PROJECT_NAME',
	OWNER: 'OWNER',
	START_DATE: 'START_DATE',
	END_DATE: 'END_DATE',
	STATUS: 'STATUS',
	PRIORITY: 'PRIORITY'
};

// Table column configuration
export const TABLE_COLUMNS = [
	{ key: 'BRAND', label: 'Brand', sortKey: SORTING_COLUMNS.BRAND },
	{ key: 'PROJECT_TYPE', label: 'Project type', sortKey: SORTING_COLUMNS.PROJECT_TYPE },
	{ key: 'PROJECT_NAME', label: 'Project name', sortKey: SORTING_COLUMNS.PROJECT_NAME },
	{ key: 'OWNER', label: 'Owner', sortKey: SORTING_COLUMNS.OWNER },
	{ key: 'START_DATE', label: 'Start date', sortKey: SORTING_COLUMNS.START_DATE },
	{ key: 'END_DATE', label: 'End date', sortKey: SORTING_COLUMNS.END_DATE },
	{
		key: 'BUYER_FIRST_SELECTION_DATE',
		label: 'Buyer first selection date',
		sortKey: SORTING_COLUMNS.BUYER_FIRST_SELECTION_DATE
	},
	{ key: 'STATUS', label: 'Status', sortKey: SORTING_COLUMNS.STATUS },
	{ key: 'PRIORITY', label: 'Priority', sortKey: SORTING_COLUMNS.PRIORITY }
];

export const INITIAL_COLUMN_SORTING_VALUE = {
	BRAND: 'BRAND,asc',
	PROJECT_TYPE: 'PROJECT_TYPE,asc',
	PROJECT_NAME: 'PROJECT_NAME,asc',
	OWNER: 'OWNER,asc',
	START_DATE: 'START_DATE,asc',
	END_DATE: 'END_DATE,asc',
	BUYER_FIRST_SELECTION_DATE: 'BUYER_FIRST_SELECTION_DATE,asc',
	STATUS: 'STATUS,asc',
	PRIORITY: 'PRIORITY,asc'
};
